import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/shared';

const base = (s: RootState) => s.voteActivity;

export const selectActivityState = base;

export const selectActivityItems = (s: RootState) => base(s).items;
export const selectActivityLoading = (s: RootState) => base(s).loading;
export const selectActivityError = (s: RootState) => base(s).error;
export const selectActivityCount = (s: RootState) => base(s).count;

export const selectActivityHasMore = createSelector(
  [selectActivityItems, selectActivityCount],
  (items, count) => items.length < count
);
